import { writable, derived } from 'svelte/store';
class WatchlistStore {
    constructor(clockType = writable(30), watchlist = writable([])) {
        this.clockType = clockType;
        this.watchlist = watchlist;
    }
    get animeListByWeekDay() {
        const stores = [this.clockType, this.watchlist];
        const fn = ([$clockType, $animeList]) => {
            const animeGroups = [[], [], [], [], [], [], []];
            $animeList.forEach((anime) => {
                const onAirTime = anime.onAir.time;
                if (!onAirTime) {
                    return;
                }
                let dateStr = onAirTime.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
                let onAirJST = new Date(dateStr);
                // 30-hour clock
                if ($clockType === 30) {
                    onAirJST.setHours(onAirJST.getHours() - 6);
                }
                animeGroups[onAirJST.getDay()].push(anime);
            });
            animeGroups.map(animeList => {
                return animeList.sort();
            });
            return animeGroups;
        };
        return derived(stores, fn);
    }
}
const watchlistStore = new WatchlistStore();
export { watchlistStore };
